import React, { useContext, useState } from "react";
import classNames from "classnames";

import { Block } from "/components/Layout";
import Image from "/components/cms/image";
import AddToBasket from "/components/AddToBasket";
import ShoppingCart from "/components/BikeOrder/ShoppingCart";

import CartContext from "/context/cart";

import styles from "./AccessoriesList.module.scss";
import { cn } from "/lib/utils";

type AccessoriesListProps = {
  nextStep: () => void;
  prevStep: () => void;
};

const AccessoriesList = ({ nextStep, prevStep }: AccessoriesListProps) => {
  const cart = useContext(CartContext);
  const accessories = cart.state?.bike?.cms?.products;
  const accessoryBundles = cart.state?.bike?.cms?.productBundles;
  const bike = cart.state?.bike;

  const [chosenBundleIndex, setChosenBundleIndex] = useState<number>(-1);

  return (
    <>
      <div>
        <Block top={6}>
          <h2>Velg tilbehør som passer til din {bike?.cms?.title}</h2>
          <p className="body-text">Tilbehør kan også legges til på et senere tidspunkt.</p>
        </Block>

        <div className="flex gap-4 mt-6 overflow-x-scroll scrollbar-hide w-full">
          {accessoryBundles?.map((bundle, index) => {
            const accessoryIds = bundle.bundle.map((b) => b.id);
            return (
              <button
                key={index}
                onClick={() => {
                  if (chosenBundleIndex === index) {
                    cart.removeAccessories();
                  } else {
                    cart.addAccessories(accessoryIds);
                  }
                  setChosenBundleIndex((val) => {
                    if (val === index) {
                      return -1;
                    }
                    return index;
                  });
                }}
                className={cn(
                  "min-w-fit px-5 py-3 rounded-full border-2 border-solid border-green text-green font-bold text-[12px] md:text-[18px]",
                  chosenBundleIndex === index && "bg-green text-white"
                )}
              >
                Velg {bundle.name}
              </button>
            );
          })}
        </div>

        <div className={styles.container}>
          {accessories?.map((item) => {
            const { id, image, title, price, href } = item;

            const isAccessorySelected = cart?.state?.accessories?.find(
              (acc) => acc.title === title
            );

            return (
              <div key={id}>
                {image ? (
                  <Image
                    imagestyle={classNames({
                      [styles.image]: true,
                      [styles["image-selected"]]: isAccessorySelected
                    })}
                    imageObject={image}
                  />
                ) : null}

                <Block top={4}>
                  <div>
                    <div>
                      <p className="body-text font-family-medium">{title}</p>
                      <Block top={2}>
                        <h5>{price} kr/mnd</h5>
                      </Block>
                      <Block top={3}>
                        {href ? (
                          <a
                            className="body-text highlight font-family-medium"
                            href={href}
                            target="_blank"
                            rel="noreferrer"
                          >
                            → Les mer
                          </a>
                        ) : null}
                      </Block>
                    </div>

                    <Block top={4} bottom={4}>
                      <AddToBasket data={item} />
                    </Block>
                  </div>
                </Block>
              </div>
            );
          })}
        </div>
      </div>

      <ShoppingCart nextStep={nextStep} prevStep={prevStep} />
    </>
  );
};

export default AccessoriesList;
